import type {TableDataType} from '../../../components/react_table/table-data-type'
import type {ColumnModel} from '../../../models/column-model'
import type {ColumnInstance} from './types'

export const getColumnModel = (column: ColumnInstance<TableDataType>): ColumnModel | undefined => {
  return getColumnMeta(column)?.columnModel
}

export const getColumnMeta = (column: ColumnInstance<TableDataType>) => {
  return column.columnDef.meta
}

/**
 * @deprecated - Use `column.getSize()` instead.
 * This function was introduced to ease the migration to TanStack Table v8,
 * and is no longer necessary.
 */
export const columnGetSize = (column: ColumnInstance<TableDataType>): number => {
  return column.getSize()
}

/**
 * @deprecated - Use `column.getStart()` instead.
 * This function was introduced to ease the migration to TanStack Table v8,
 * and is no longer necessary.
 */
export const columnTotalLeft = (column: ColumnInstance<TableDataType>): number => {
  return column.getStart()
}

/**
 * @deprecated - Use `column.getIsGrouped()` instead.
 * This function was introduced to ease the migration to TanStack Table v8,
 * and is no longer necessary.
 */
export const columnIsGrouped = (column: ColumnInstance<TableDataType>): boolean => {
  return column.getIsGrouped()
}
